<template>
	<div class="scenario-modal-container absolute flex flex-col items-center justify-center" v-if="node">
		<!-- Modal -->
		<div
		class="scenario-modal bg-white rounded-md shadow-dark z-10 flex flex-col mb-28 mt-4"
		:class="{ 'media-modal': (currentMedia ? true : false) }">

			<!-- Modal Header -->
			<div class="scenario-modal-header relative z-1">
				<!-- Scenario Results Header -->
				<ResultsHeader v-if="scenarioEnd" />

				<!-- Game Header -->
				<GameHeader
				v-else-if="currentGame"
				:game="currentGame" />

				<!-- PDF Header -->
				<PDFViewHeader
				v-else-if="currentPDF"
				:title="node.title"
				:pdf="currentPDF"
				@previous="previousPDFPage()"
				@next="nextPDFPage()"
				@close="closeModal('pdf_close')"/>

				<!-- Game Header -->
				<MediaPlayerHeader
				v-else-if="currentMedia"
				:title="node.title"
				:media="currentMedia" />

				<!-- Simple Proposal Header -->
				<SimpleProposalHeader
				v-else-if="currentProposal"
				:title="node.title"
				:proposal="currentProposal" />
			</div>

			<!-- Modal content -->
			<div class="scenario-modal-content">
				<!-- Scenario Results -->
				<Results
				v-if="scenarioEnd"
				:games="games"
				:game-results="gameResults" />

				<!-- Game -->
				<Game 
				v-else-if="currentGame" 
				:game="currentGame" 
				@ended="gameEnded"
				@next="closeModal('game_next')" />

				<!-- PDF -->
				<PDFView 
				v-else-if="currentPDF" 
				:pdf="currentPDF" 
				ref="pdf" />

				<!-- Media node -->
				<MediaPlayer
				v-else-if="currentMedia"
				:media="currentMedia"
				ref="media"
				@next="closeModal('media_next')"
				@ended="closeModal('media_end')" />

				<!-- Simple Proposal node -->
				<SimpleProposal
				v-else-if="currentProposal"
				:proposal="currentProposal"
				ref="media"
				@next="closeModal('simple_proposal_next')" />
			</div>
		</div>
	</div>
</template>

<script>
	import ResultsHeader from '@/components/scenario/modal/ResultsHeader'
	import GameHeader from '@/components/scenario/modal/GameHeader'
	import PDFViewHeader from '@/components/scenario/modal/PDFViewHeader'
	import MediaPlayerHeader from '@/components/scenario/modal/MediaPlayerHeader'
	import SimpleProposalHeader from '@/components/scenario/modal/SimpleProposalHeader'

	import Results from '@/components/scenario/modal/Results'
	import Game from '@/components/scenario/modal/Game'
	import PDFView from '@/components/scenario/modal/PDFView'
	import MediaPlayer from '@/components/scenario/modal/MediaPlayer'
	import SimpleProposal from '@/components/scenario/modal/SimpleProposal'

	export default {
		name: 'Modal',
		props: {
			node: {
				type: Object,
				required: true,
				default: null,
			},
			assets: {
				type: Object,
				required: true,
				default: () => {},
			},
			games: {
				type: Object,
				required: true,
				default: () => {},
			},
			proposals: {
				type: Object,
				required: true,
				default: () => {},
			},
			scenarioEnd: {
				type: Boolean,
				required: false,
				default: false,
			},
			gameResults: {
				type: Object,
				required: false,
				default: () => {},
			},
		},
		components: {
			GameHeader,
			PDFViewHeader,
			ResultsHeader,
			MediaPlayerHeader,
			SimpleProposalHeader,
			Game,
			PDFView,
			Results,
			MediaPlayer,
			SimpleProposal,
		},
		computed:{
			currentGame() {
				if (this.node.type.slug != 'game' || !this.games)
					return null

				return this.games[this.node.node_content]
			},
			currentPDF() {
				if (this.node.type.slug != 'pdf' || !this.assets)
					return null

				return this.assets[this.node.node_content]
			},
			currentMedia() {
				if (this.node.type.slug != 'media' || !this.assets)
					return null

				return this.assets[this.node.node_content]
			},
			currentProposal() {
				if (this.node.type.slug != 'simple_proposal' || !this.proposals)
					return null

				return this.proposals[this.node.node_content]
			}
		},
		methods: {
			closeModal(origin) {
				this.$emit('close', origin)
			},
			previousPDFPage() {
				if (this.$refs.pdf)
					this.$refs.pdf.previousPage()
			},
			nextPDFPage() {
				if (this.$refs.pdf)
					this.$refs.pdf.nextPage()
			},
			gameEnded(results) {
				this.$emit('game-ended', results)
			},
			gameSuccess() {}, // todo
			gameFailure() {}, // todo
		},
	}
</script>

<style lang="scss" scoped>

.scenario-modal-container {
	top: 50px;
	right: 0;
	bottom: 0;
	left: 0;
}

.scenario-modal { // todo: improve responsive
	width: 980px;
	max-width: 90%;
	max-height: 85%;


	&.media-modal {
		width: auto;
		max-width: 70%;
	}

	&-header {
		box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);// todo
	}

	&-content {
		overflow: auto;
		height: 100%;
	}
}

</style>
